export class Country{
    id?: number;
    name?: string;
}